/**
 * SolutionsAppStore — `/solutions/app-store` route.
 * Body is the hand-built design from `solutions-app-store.html`.
 * Includes the search filter and FAQ accordion driven by the file's
 * own inline script. Navbar + Footer + App.js routing unchanged.
 */
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { SolutionsAppStoreHero } from "../components/SolutionsAppStoreHero";

export default function SolutionsAppStore() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="solutions-app-store-page">
      <Helmet>
        <title>T-REX AppStore : Where the apps operate together.</title>
      </Helmet>
      <Navbar />
      <div aria-hidden="true" style={{ height: 64 }} />
      <SolutionsAppStoreHero />
      <Footer />
    </main>
  );
}
